import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import ACTIONS from '../../actions/lexon';
import CU_ACTIONS from '../../actions/user';
import { setFormValues } from '../../actions/login';
import { clearUserCredentials, setService } from '../../actions/application';
import { PROVIDER } from '../../constants';
import {
  getUserAccounts,
  getUserAccount,
  getDefaultAccount,
  getTokenImap
} from '../../services/accounts';
import { getBasicAuthCredentials } from '../../services/auth-credentials';
import { removeState } from '../../services/state';
import * as base64 from 'base-64';
import { withRouter } from '../../hocs/withRouter';
import {
  parseJwt,
  getUserId,
  getIdCasefile,
  getBbdd,
  getIdCompany,
  getMailContacts,
  getIdMail,
  getImapFolder,
  getTitle,
  getIdActuation,
  getIdCalendar,
  getIdEvent,
  getIdClienteLef,
  getEnv,
  getIdClienteNavision,
  getRoles,
  getUserName,
  getIdApp,
  getIdUserApp,
  getAppConnect,
  getIdResponsable,
  getAccount,
  getAcceptCookies
} from '../../services/jwt';

const SESSION_USER_KEY = 'LEXON_SESSION_USER_ID';

class UserCalendar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      readyToRedirect: false,
      readyToRedirectToLogin: false,
      isNewAccount: false,
      mountEnded: false,
      searchDefault: false
    };

    this.isUniqueAccountByProvider = this.isUniqueAccountByProvider.bind(this);
  }

  async componentDidMount() {
    let parametros;
    let account;

    if (
      this.props.location.search.indexOf('account=') > -1 ||
      this.props.location.search.indexOf('prov=') > -1
    ) {
      //const account64 = this.props.location.search.split("account=")[1];
      parametros = new URLSearchParams(this.props.location.search);
      const acParam = parametros.get('account');
      if (acParam) {
        // Get user account
        try {
          account = base64.decode(acParam);
          if (account) {
            this.props.setAccount(account);
          }
        } catch (e) {
          console.error('Error decoding account:', e);
        }
      }
    }

    const payload = this.props.match.params.token
      ? parseJwt(this.props.match.params.token)
      : undefined;

    if (payload && window !== window.top) {
      const newLexonUserId = getUserId(payload);
      const lastLexonUserId = localStorage.getItem(SESSION_USER_KEY);
      if (newLexonUserId) {
        if (lastLexonUserId && lastLexonUserId !== String(newLexonUserId)) {
          // Cambio de cuenta de Lexon detectado: limpiar la sesion de correo
          // de la cuenta anterior antes de mostrar el calendario de la nueva.
          removeState();
          localStorage.setItem(SESSION_USER_KEY, String(newLexonUserId));
          window.location.reload();
          return;
        }
        localStorage.setItem(SESSION_USER_KEY, String(newLexonUserId));
      }
    }

    if (payload) {
      const aux = { ...payload };
      delete aux.exp;
      // PEC-1557: el consentimiento de cookies se deriva SIEMPRE del token de entrada (nunca del
      // currentUser persistido) para que un `true` antiguo no arranque Clarity sin consentimiento.
      aux.accept_cookies = getAcceptCookies(payload);
      window.currentUser = aux;
      this.props.setCurrentUser(aux);
    }

    const idUserResponsable = getIdResponsable(payload);
    this.props.setIdResponsable(idUserResponsable);

    let user = this.props.match.params.token
      ? getUserId(payload)
      : this.props.match.params.idUser;
    const casefile = this.props.match.params.token
      ? getIdCasefile(payload)
      : this.props.match.params.idCaseFile;
    const bbdd = this.props.match.params.token
      ? getBbdd(payload)
      : this.props.match.params.bbdd;
    const idCompany = this.props.match.params.token
      ? getIdCompany(payload)
      : this.props.match.params.idCompany;
    const idMessage = this.props.match.params.token
      ? getIdMail(payload)
      : this.props.match.params.idMessage;
    let idFolder = this.props.match.params.token
      ? getImapFolder(payload)
      : this.props.match.params.idFolder;
    const mailContacts = this.props.match.params.token
      ? getMailContacts(payload)
      : this.props.match.params.mailContacts;
    const idEvent = this.props.match.params.token
      ? getIdEvent(payload)
      : null;
    const idActuation = this.props.match.params.token
      ? getIdActuation(payload)
      : null;
    const idCalendar = this.props.match.params.token
      ? getIdCalendar(payload)
      : null;
    const title = this.props.match.params.token
      ? getTitle(payload)
      : null;
    const idClienteLef = this.props.match.params.token
      ? getIdClienteLef(payload)
      : null;
    const appConnect = this.props.match.params.token
      ? getAppConnect(payload)
      : null;
    const accountToken = this.props.match.params.token
      ? getAccount(payload)
      : null;

    if (window !== window.top) {
      if (account === undefined && accountToken === null) {
        account = (idCalendar) ? idCalendar.split('/')[4] : undefined;
        if (account === undefined) {
          this.setState({searchDefault: true});
        }
      } else if (account === undefined && accountToken) {
        account = accountToken;
      }
      this.props.setAccount(account);
    } else {
      if (account === undefined && accountToken === null) {
        this.setState({searchDefault: true});
      }
    }

    this.props.setService('calendar');
    this.props.setIdEvent(idEvent);
    this.props.setIdActuation(idActuation);
    this.props.setIdCalendar(idCalendar);
    this.props.setTitle(title);
    this.props.setIdClientLef(idClienteLef);
    this.props.setAppConnect(appConnect);

    this.props.match.params.token
      ? {
        idClienteNavision: getIdClienteNavision(payload),
        idClienteLef: getIdClienteLef(payload),
        roles: getRoles(payload),
        name: getUserName(payload),
        idApp: getIdApp(payload),
        idUserApp: getIdUserApp(payload),
        env: getEnv(payload)
      }
      : user;

    if (this.props.location.search.indexOf('prov=') > -1) {
      user = `${parametros.get('prov')}${user}`;
    }

    this.props.setUser(user);

    if (idFolder === null || idFolder === undefined || idFolder === 'NULL') {
      idFolder = 'INBOX';
    }

    if (casefile) {
      this.props.setCaseFile({
        casefile: casefile,
        bbdd: bbdd,
        idCompany: idCompany
      });
    } else if (bbdd) {
      this.props.setDataBase({
        bbdd: bbdd,
        idCompany: idCompany
      });
    }

    if (idMessage) {
      this.props.setIdEmail({
        idEmail: idMessage,
        idFolder: idFolder,
        emailShown: false
      });
    }

    if (mailContacts) {
      this.props.setMailContacts(mailContacts);
    }

    if (this.props.match.params.token) {
      this.props.setLexonToken(this.props.match.params.token);
    }
    this.setState({ isNewAccount: user.slice(2, 3) === '1' ? true : false, mountEnded: true });
    const portalToken = await getTokenImap(this.props.match.params.token);

    if (portalToken && portalToken.data) {
      this.props.setToken(portalToken.data);
    }


  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.lexon) !== JSON.stringify(this.props.lexon)) {
      if (this.props.lexon.isNewAccount) {
        removeState();
        this.setState({
          readyToRedirect: true
        });
      } else if (window !== window.top) {
        if (this.props.lexon.account && this.state.mountEnded) {
          this.getAccountCredentials();
        } else {
          if (this.props.lexon.account === undefined && this.state.mountEnded && this.state.searchDefault) {
            this.getDefaultAcc();
          }
        }
      } else if (this.props.lexon.account &&
         prevProps.lexon.account !== this.props.lexon.account) {
        this.isUniqueAccountByProvider();
      } else if (this.state.mountEnded) {
        this.getDefaultAcc();
      }
    } else if (this.state.mountEnded && !this.state.readyToRedirect) {
      this.setState({readyToRedirect: true});
    }
  }

  async getAccountCredentials() {
    const { lexon } = this.props;
    const result = await getUserAccount(lexon.userId, lexon.account, lexon.lexonToken);
    if (result.infos.length > 0 && result.data === null) {
      const noExistUserAccount = result.infos.some(x => x.code === 'AC-10');
      if (noExistUserAccount) {
        window.top.postMessage(
          JSON.stringify({
            idEvent: undefined,
            actionCancelled: true,
            selectedDate: undefined,
            removed: false,
            message: "Not Account",
            isAuth: false
          }),
          window.URL_LEXON
        );
      }
    }
    if (result.errors.length === 0 && result.data !== null) {
      const config = {
        serverHost: result.data.configAccount.imap,
        serverPort: result.data.configAccount.imapPort,
        user: result.data.configAccount.imapUser,
        password: result.data.configAccount.imapPass,
        imapSsl: result.data.configAccount.imapSsl,
        smtpHost: result.data.configAccount.smtp,
        smtpPort: result.data.configAccount.smtpPort,
        smtpSsl: result.data.configAccount.smtpSsl,
        smtpTls: result.data.configAccount.smtpTls
      };

      this.props.setFormValues(config);

      // Obtener y guardar las credenciales de NextCloud
      try {
        const basicAuthToken = await getBasicAuthCredentials(lexon.userId, lexon.account, lexon.lexonToken);
        this.props.setNextcloudAccountAuth(basicAuthToken);
      } catch (error) {
        console.error('Error getting NextCloud credentials:', error);
      }

      this.setState({
        readyToRedirect: true
      });
    }
  }

  async getDefaultAcc() {
    const { lexon } = this.props;
    const result = await getDefaultAccount(lexon.userId, lexon.lexonToken);
    if (result.errors.length === 0 && result.data !== null && result.data.configAccount !== null) {
      const config = {
        serverHost: result.data.configAccount.imap,
        serverPort: result.data.configAccount.imapPort,
        user: result.data.configAccount.imapUser,
        password: result.data.configAccount.imapPass,
        imapSsl: result.data.configAccount.imapSsl,
        smtpHost: result.data.configAccount.smtp,
        smtpPort: result.data.configAccount.smtpPort,
        smtpSsl: result.data.configAccount.smtpSsl,
        smtpTls: result.data.configAccount.smtpTls
      };
      this.props.setFormValues(config);

      // Obtener y guardar las credenciales de NextCloud
      try {
        const basicAuthToken = await getBasicAuthCredentials(lexon.userId, result.data.configAccount.imapUser, lexon.lexonToken);
        this.props.setNextcloudAccountAuth(basicAuthToken);
      } catch (error) {
        console.error('Error getting NextCloud credentials:', error);
      }

      this.props.setConfigCalendar(result.data.configCalendar);
      if (!lexon.account) {
        this.props.setAccount(result.data.configAccount.imapUser);
      }
      this.setState({
        readyToRedirect: true
      });
    }
  }

  async isUniqueAccountByProvider() {
    const { lexon } = this.props;
    const result = await getUserAccounts(lexon.userId, lexon.lexonToken);

    if (result.errors.length === 0) {
      const accountsByProvider = result.data.accounts.filter(
        account => account.provider === PROVIDER
      );
      const userAccount = accountsByProvider.filter(a => a.email === this.props.lexon.account);
      if (userAccount && Array.isArray(userAccount) && userAccount.length > 0) {
        this.props.setConfigCalendar(userAccount.configCalendar);
        const config = {
          serverHost: userAccount[0].configAccount.imap,
          serverPort: userAccount[0].configAccount.imapPort,
          user: userAccount[0].configAccount.imapUser,
          password: userAccount[0].configAccount.imapPass,
          imapSsl: userAccount[0].configAccount.imapSsl,
          smtpHost: userAccount[0].configAccount.smtp,
          smtpPort: userAccount[0].configAccount.smtpPort,
          smtpSsl: userAccount[0].configAccount.smtpSsl,
          smtpTls: userAccount[0].configAccount.smtpTls
        };
        this.props.setFormValues(config);

        // Obtener y guardar las credenciales de NextCloud
        try {
          const basicAuthToken = await getBasicAuthCredentials(lexon.userId, userAccount[0].configAccount.imapUser, lexon.lexonToken);
          this.props.setNextcloudAccountAuth(basicAuthToken);
        } catch (error) {
          console.error('Error getting NextCloud credentials:', error);
        }
      } else {
        console.error('Account not found error');
        window.localStorage.clear();
        this.props.logout();
        const urlRedirect = lexon.token ? `${window.URL_SELECT_ACCOUNT}/access/${lexon.token}/` : `${window.URL_SELECT_ACCOUNT}/user/${lexon.userId}/encrypt/0`;
        window.open(urlRedirect, '_self');
      }
      this.setState({
        readyToRedirect: true
      });
    }
  }

  render() {
    const {
      readyToRedirect,
    } = this.state;

    if (readyToRedirect) {
      return <Navigate to='/calendar' />;
    }

    return null;
  }
}

const mapStateToProps = state => ({
  lexon: state.lexon
});

const mapDispatchToProps = dispatch => ({
  setUser: user => dispatch(ACTIONS.setUser(user)),
  setAccount: account => dispatch(ACTIONS.setAccount(account)),
  setCaseFile: casefile => dispatch(ACTIONS.setCaseFile(casefile)),
  setDataBase: dataBase => dispatch(ACTIONS.setDataBase(dataBase)),
  setIdEmail: emailInfo => dispatch(ACTIONS.setIdEmail(emailInfo)),
  setFormValues: formValues => dispatch(setFormValues(formValues)),
  setMailContacts: mailContacts =>
    dispatch(ACTIONS.setMailContacts(mailContacts)),
  logout: () => {
    dispatch(clearUserCredentials());
  },
  setToken: token => dispatch(ACTIONS.setToken(token)),
  setLexonToken: lexonToken => dispatch(ACTIONS.setLexonToken(lexonToken)),
  setCurrentUser: payload => dispatch(CU_ACTIONS.setCurrentUser(payload)),
  setIdEvent: id => dispatch(ACTIONS.setIdEvent(id)),
  setIdActuation: id => dispatch(ACTIONS.setIdActuation(id)),
  setIdCalendar: id => dispatch(ACTIONS.setIdCalendar(id)),
  setTitle: title => dispatch(ACTIONS.setTitle(title)),
  setIdClientLef: id => dispatch(ACTIONS.setIdClientLef(id)),
  setConfigCalendar: config => dispatch(ACTIONS.setConfigCalendar(config)),
  setAppConnect: appConnect => dispatch(ACTIONS.setAppConnect(appConnect)),
  setService: service => dispatch(setService(service)),
  setIdResponsable: config => dispatch(ACTIONS.setIdResponsable(config)),
  setNextcloudAccountAuth: password => dispatch(ACTIONS.setNextcloudAccountAuth(password))

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserCalendar));
